import type { EditOrganizationInvestorsPayload } from '@/api/v4/organization.api';
import { editOrganizationInvestors } from '@/api/v4/organization.api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { companyIdState } from '../company.state';
import { useCompanyFetchMode } from '../company-fetch-context';
import { QueryKey } from '@/config/query-client';
import { useAtomValue } from 'jotai';

export const useEditCompanyInvestors = () => {
  const companyId = useAtomValue(companyIdState);
  const fetchMode = useCompanyFetchMode();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      investors: EditOrganizationInvestorsPayload['investors'],
    ) => {
      if (!companyId) return;

      return editOrganizationInvestors(companyId, { investors });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.CompanyInvestors, fetchMode, companyId],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.LastActivities],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.LastActivitiesCount],
      });
    },
  });
};
